import styled from 'styled-components';
import Colors from 'assets/Colors.js';

const Title = styled.div`
  color: ${Colors.text_primary};
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
`;

const OptionsBoxContainer = styled.div`
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
  border-radius: 5px;
  margin-top: 18px;
  display: grid;
  grid-template-columns: 1;
`;

const OptionRow = styled.div`
  border-bottom: 0.5px solid ${Colors.line_separator};
  min-height: 47px;
  display: flex;
  align-items: center;
  padding-left: 18px;
  padding-right: 18px;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 21px;
  color: ${Colors.text_primary};
  background-color: ${(props) => props.color};
`;

const OptionRowStock = styled.div`
  border-bottom: 0.5px solid ${Colors.line_separator};
  min-height: 47px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 18px;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 21px;
  color: ${Colors.text_primary};
`;

const Button = styled.div`
  width: 73px;
  height: 34px;
  background: ${Colors.primary};
  color: ${Colors.text_on_primary};
  border-radius: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px;
  margin-left: 18px;
  cursor: pointer;
`;

const OptionTextContainer = styled.div`
  flex-grow: 1;
`;
const SlockSectionHeader = styled.div`
  flex-grow: 1;
`;

const SlockSectionTitleHeader = styled.div`
  font-style: normal;
  font-size: 15px;
  align: left;
  font-weight: 500;
`;

const EditableText = styled.input`
  border: none;
  text-align: right;
  flex-grow: 2;
  background: none;
  outline: none;
`;

export default {
  Title,
  OptionsBoxContainer,
  OptionRow,
  OptionTextContainer,
  EditableText,
  SlockSectionHeader,
  SlockSectionTitleHeader,
  OptionRowStock,
  Button
};
